import { buildUrl } from "../util/integration"

import {
    authorizedFetch,
} from "./http_api";

const HTTP_METHOD =
    Object.freeze({
        get: "GET",
        post: "POST",
        delete: "DELETE",
    });

const ENDPOINT =
    Object.freeze({
        available:
            "auction/available",

        auction: (
            auctionId,
        ) => {
            return (
                `auction/${auctionId}`
            );
        },

        status: (
            auctionId,
        ) => {
            return (
                `auction/${auctionId}/status`
            );
        },

        bid: (
            auctionId,
        ) => {
            return (
                `auction/${auctionId}/bid`
            );
        },

        abortion: (
            auctionId,
        ) => {
            return (
                `auction/${auctionId}/abortion`
            );
        },
    });

const buildRequestUrl = (
    endpoint,
    queryParameters = {},
) => {
    const query =
        new URLSearchParams();

    Object.entries(
        queryParameters,
    ).forEach(([
        name,
        value,
    ]) => {
        if (
            value !== null
            && value !== undefined
        ) {
            query.set(
                name,
                String(value),
            );
        }
    });

    const queryString =
        query.toString();

    return queryString === ""
        ? buildUrl(endpoint)
        : buildUrl(
            `${endpoint}?${queryString}`,
        );
};

export const fetchAvailableAuctionsAPI = (
    accessToken,
    userId,
) => {
    return authorizedFetch(
        accessToken,

        buildRequestUrl(
            ENDPOINT.available,
            {
                userId,
            },
        ),

        {
            method:
                HTTP_METHOD.get,
        },
    );
};

export const fetchAuctionAPI = (
    accessToken,
    auctionId,
    userId,
) => {
    return authorizedFetch(
        accessToken,

        buildRequestUrl(
            ENDPOINT.auction(
                auctionId,
            ),
            {
                userId,
            },
        ),

        {
            method:
                HTTP_METHOD.get,
        },
    );
};

export const fetchAuctionStatusAPI = (
    accessToken,
    auctionId,
    userId,
) => {
    return authorizedFetch(
        accessToken,

        buildRequestUrl(
            ENDPOINT.status(
                auctionId,
            ),
            {
                userId,
            },
        ),

        {
            method:
                HTTP_METHOD.get,
        },
    );
};

export const bidAPI = (
    accessToken,
    auctionId,
    bidderId,
    bid,
) => {
    return authorizedFetch(
        accessToken,

        buildRequestUrl(
            ENDPOINT.bid(
                auctionId,
            ),
            {
                bidderId,
                bid,
            },
        ),

        {
            method:
                HTTP_METHOD.post,
        },
    );
};

export const abortAuctionAPI = (
    accessToken,
    auctionId,
) => {
    return authorizedFetch(
        accessToken,

        buildRequestUrl(
            ENDPOINT.abortion(
                auctionId,
            ),
        ),

        {
            method:
                HTTP_METHOD.delete,
        },
    );
};